







import {
  Component,
  Vue,
} from 'vue-property-decorator';

import api from '@/api';
import PrimaryButton from '@/components/PrimaryButton.vue';
import { ProductVariant } from '@/models';

const BuyNowButtonProps = Vue.extend({
  props: {
    variant: {
      type: ProductVariant,
      required: true,
    },
    quantity: {
      type: Number,
      default: 1,
    },
  },
});

@Component({
  components: {
    PrimaryButton,
  },
})
export default class BuyNowButton extends BuyNowButtonProps {
  public checkout() {
    // TODO: Show spinner.

    // Create a draft order and include the variant in the order.
    api.createDraftOrder({
      items: [
        {
          variantId: this.variant.id,
          quantity: this.quantity,
        },
      ],
    }).then((orderData) => (this.$router.push({
      name: 'checkout',
      params: {
        draftOrderId: orderData.id,
      },
    })));
  }
}

